import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetovidharbhcabservice() {



    const cardData = {

keyword: "Pune to Vidarbha Cab Service",

headingDescription:
    "Rising Cab Service offers reliable and comfortable Pune to Vidarbha Cab Service for long-distance travelers, families, business passengers, and tourists. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for a safe and smooth highway journey across Maharashtra. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for business, family visits, pilgrimage, or tourism, Rising Cab Service ensures a hassle-free travel experience across the Vidarbha region.",

topPlaces: [
    {
        title: "Nagpur",
        description:
            "Nagpur is the largest city in Vidarbha and a major commercial and transportation hub. Known as the Orange City, it is famous for Deekshabhoomi, Futala Lake, Sitabuldi Fort, and its central location in India."
    },
    {
        title: "Amravati",
        description:
            "Amravati is an important city in Vidarbha known for Ambadevi Temple, Chikhaldara Hill Station nearby, and its growing educational and industrial development."
    },
    {
        title: "Chandrapur",
        description:
            "Chandrapur is known for its rich forest reserves, Tadoba Andhari Tiger Reserve, and limestone industries. It is a popular destination for wildlife tourism and industrial visits."
    },
    {
        title: "Gondia",
        description:
            "Gondia is a border district near Madhya Pradesh known for rice production, green landscapes, and its connectivity to nearby natural and forest regions."
    },
    {
        title: "Wardha",
        description:
            "Wardha is a historic city associated with Mahatma Gandhi’s Sevagram Ashram. It is an important center for Gandhian philosophy and peaceful rural tourism."
    },
    {
        title: "Yavatmal",
        description:
            "Yavatmal is a major agricultural district in Vidarbha known for cotton production, rural landscapes, and growing industrial development."
    },
    {
        title: "Bhandara",
        description:
            "Bhandara is known as the 'Rice Bowl of Maharashtra' and features lakes, temples, and scenic countryside surroundings ideal for peaceful travel."
    },
    {
        title: "Akola",
        description:
            "Akola is a developing city in Vidarbha known for agriculture, cotton trade, and regional business activities, making it an important commercial hub."
    },
    {
        title: "Melghat Tiger Reserve",
        description:
            "Melghat Tiger Reserve is a rich wildlife sanctuary in Vidarbha known for Bengal tigers, dense forests, and eco-tourism opportunities."
    },
    {
        title: "Chikhaldara Hill Station",
        description:
            "Chikhaldara is the only hill station in Vidarbha, famous for its cool climate, valleys, waterfalls, and panoramic viewpoints, making it a popular weekend getaway."
    }
],



services: [
    {
        name: "Vidarbha Taxi Service from Pune",
        description:
            "Rising Cab Service offers Vidarbha Taxi Service from Pune for safe, comfortable, and reliable long-distance travel across all major cities in the Vidarbha region. This service is ideal for business travel, family visits, government work, tourism, and village connectivity. We provide well-maintained AC cars, experienced highway drivers, door-to-door pickup and drop, and transparent pricing. Customers can choose from sedan, SUV, Innova, Innova Crysta, and Tempo Traveller options depending on group size and comfort requirements. With flexible one-way and round-trip packages, 24x7 booking support, and customized travel plans, we ensure a smooth and stress-free journey from Pune to Vidarbha destinations like Nagpur, Amravati, Akola, Yavatmal, Buldhana, Chandrapur, and Gadchiroli."

    },
    {
        name: "Pune to Vidarbha Taxi Booking",
        description:
            "Book Pune to Vidarbha Taxi Booking with Rising Cab Service for convenient and affordable intercity travel. We offer instant confirmation, flexible pickup timing, clean vehicles, and professional drivers for all types of long-distance journeys across the Vidarbha region."
    },
    {
        name: "Outstation Cab Pune to Vidarbha",
        description:
            "Rising Cab Service provides Outstation Cab Pune to Vidarbha with safe highway travel, well-maintained vehicles, and experienced chauffeurs for smooth long-distance transportation to multiple cities in Vidarbha."
    },
    {
        name: "Pune to Vidarbha Tour Cab",
        description:
            "Our Pune to Vidarbha Tour Cab service is designed for tourists and families exploring cultural, religious, and natural attractions in Vidarbha. We offer comfortable travel, flexible stops, and customized tour plans."
    },
    {
        name: "Best Vidarbha Cab Service Pune",
        description:
            "Rising Cab Service is known for Best Vidarbha Cab Service Pune with reliable vehicles, professional drivers, and affordable pricing for all types of intercity travel needs."
    },
    {
        name: "Round Trip Vidarbha Cab Pune",
        description:
            "Book Round Trip Vidarbha Cab Pune for return journey convenience with flexible waiting time, customized schedules, and comfortable travel options for families and corporate travelers."
    },
    {
        name: "Luxury Cab Pune to Vidarbha",
        description:
            "Rising Cab Service offers Luxury Cab Pune to Vidarbha with premium vehicles like Innova Crysta and SUV options for high-comfort long-distance travel with professional chauffeurs."
    },
    {
        name: "Pune to Vidarbha Car Rental",
        description:
            "Our Pune to Vidarbha Car Rental service provides flexible self-planned or chauffeur-driven travel options for business, tourism, and family trips across Vidarbha cities."
    },
    {
        name: "One Way Vidarbha Taxi Pune",
        description:
            "Book One Way Vidarbha Taxi Pune for affordable single-direction travel with experienced drivers, comfortable AC vehicles, and door-to-door service."
    },
    {
        name: "Pune to Yavatmal Cab Service",
        description:
            "Rising Cab Service provides Pune to Yavatmal Cab Service with safe, reliable, and comfortable travel options for families, business travelers, and government visits."
    },
    {
        name: "Pune to Yavatmal Taxi Booking",
        description:
            "Book Pune to Yavatmal Taxi Booking for instant and advance reservations with professional drivers and well-maintained vehicles for long-distance travel."
    },
    {
        name: "Pune to Yavatmal Innova Crysta",
        description:
            "Rising Cab Service offers Pune to Yavatmal Innova Crysta for premium comfort, spacious seating, and smooth highway travel for family and group journeys."
    },
    {
        name: "Pune to Yavatmal Tempo Traveller",
        description:
            "Our Pune to Yavatmal Tempo Traveller service is ideal for large groups, providing comfortable seating, ample luggage space, and safe long-distance travel."
    },
    {
        name: "Pune to Yavatmal Outstation Taxi",
        description:
            "Book Pune to Yavatmal Outstation Taxi for safe and reliable intercity travel with experienced drivers and flexible booking options."
    },
    {
        name: "Pune to Gadchiroli Cab Service",
        description:
            "Rising Cab Service provides Pune to Gadchiroli Cab Service for remote travel with safe drivers, reliable vehicles, and comfortable long-distance journeys."
    },
    {
        name: "Pune to Gadchiroli Taxi",
        description:
            "Our Pune to Gadchiroli Taxi service ensures secure and affordable transportation for long-distance travel with professional chauffeurs."
    },
    {
        name: "Pune to Gadchiroli SUV Cab",
        description:
            "Book Pune to Gadchiroli SUV Cab for spacious and comfortable travel suitable for families and group passengers on long routes."
    },
    {
        name: "Pune to Gadchiroli Long Distance Cab",
        description:
            "Rising Cab Service offers Pune to Gadchiroli Long Distance Cab with safe driving, AC vehicles, and reliable intercity transportation."
    },
    {
        name: "Pune to Gadchiroli Travel Taxi",
        description:
            "Our Pune to Gadchiroli Travel Taxi service provides comfortable and affordable long-distance travel with experienced drivers and flexible schedules."
    },
    {
        name: "Pune to Buldhana Cab Service",
        description:
            "Book Pune to Buldhana Cab Service for safe and reliable intercity travel with clean vehicles and professional chauffeurs."
    },
    {
        name: "Pune to Buldhana Taxi Booking",
        description:
            "Rising Cab Service provides Pune to Buldhana Taxi Booking with instant confirmation and affordable travel options."
    },
    {
        name: "Pune to Buldhana Innova Cab",
        description:
            "Our Pune to Buldhana Innova Cab service offers premium comfort and spacious seating for long-distance family and corporate travel."
    },
    {
        name: "Pune to Buldhana Tempo Traveller",
        description:
            "Book Pune to Buldhana Tempo Traveller for group travel with comfortable seating and safe long-distance transportation."
    },
    {
        name: "Pune to Buldhana One Way Cab",
        description:
            "Rising Cab Service offers Pune to Buldhana One Way Cab for economical single-trip travel with reliable drivers."
    },
    {
        name: "Best Pune to Nagpur Cab Service",
        description:
            "Choose Best Pune to Nagpur Cab Service for premium intercity travel with comfortable vehicles, experienced chauffeurs, and transparent pricing."
    },
    {
        name: "Cheap Pune to Vidarbha Taxi",
        description:
            "Rising Cab Service offers Cheap Pune to Vidarbha Taxi with budget-friendly fares and safe, reliable long-distance travel options."
    },
    {
        name: "Book Cab from Pune to Amravati",
        description:
            "Book Cab from Pune to Amravati for smooth and comfortable intercity travel with professional drivers and AC vehicles."
    },
    {
        name: "Tempo Traveller Pune to Akola",
        description:
            "Our Tempo Traveller Pune to Akola service is perfect for group travel with spacious seating and comfortable long-distance journey options."
    },
    {
        name: "Urbania on Rent Pune to Chandrapur",
        description:
            "Rising Cab Service provides Urbania on Rent Pune to Chandrapur for luxury group travel with premium comfort and large seating capacity."
    },
    {
        name: "Family Cab Service Pune to Yavatmal",
        description:
            "Book Family Cab Service Pune to Yavatmal for safe, comfortable, and affordable travel designed for families and group passengers."
    },
    {
        name: "Luxury Cab Pune to Vidarbha",
        description:
            "Rising Cab Service offers Luxury Cab Pune to Vidarbha with premium vehicles, professional chauffeurs, and high-comfort intercity travel experience."
    },
    {
        name: "Pune to Nagpur Cab",
        description:
            "Our Pune to Nagpur Cab service ensures safe and reliable long-distance travel with flexible booking and comfortable AC vehicles."
    },
    {
        name: "Pune to Vidarbha Taxi",
        description:
            "Book Pune to Vidarbha Taxi for affordable and convenient intercity travel across all major Vidarbha destinations."
    },
    {
        name: "Pune to Amravati Cab",
        description:
            "Rising Cab Service provides Pune to Amravati Cab for smooth and safe travel with professional drivers and well-maintained vehicles."
    }
],

tableData: [
    ["Vidarbha Taxi Service from Pune", "Pune to Vidarbha Taxi Booking"],
    ["Outstation Cab Pune to Vidarbha", "Pune to Vidarbha Tour Cab"],
    ["Best Vidarbha Cab Service Pune", "Round Trip Vidarbha Cab Pune"],
    ["Luxury Cab Pune to Vidarbha", "Pune to Vidarbha Car Rental"],
    ["One Way Vidarbha Taxi Pune", "Cheap Pune to Vidarbha Taxi"],
    ["Pune to Yavatmal Cab Service", "Pune to Gadchiroli Taxi"],
    ["Pune to Buldhana Cab Service", "Pune to Buldhana Innova Cab"],
    ["Pune to Buldhana Tempo Traveller", "Pune to Nagpur Cab Service"],
    ["Book Cab from Pune to Amravati", "Tempo Traveller Pune to Akola"],
    ["Urbania on Rent Pune to Chandrapur", "Family Cab Service Pune to Yavatmal"]
],




whychoose: [
    {
        WhyChooseheading: "Dedicated Pune to Vidarbha Cab Services",
        WhyChoosedescription: "Rising Cab Service provides comfortable cab transportation from Pune to major Vidarbha destinations including Nagpur, Amravati, Akola, Yavatmal, Wardha, Chandrapur, Bhandara, Gondia, and Washim."
    },
    {
        WhyChooseheading: "Ideal for Long-Distance Maharashtra Travel",
        WhyChoosedescription: "Our service is suitable for family visits, business travel, educational trips, medical appointments, social events, and tourism across the Vidarbha region."
    },
    {
        WhyChooseheading: "Travel Options for Every Passenger Group",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to their travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you need a one-way transfer to Vidarbha or a complete return package, we offer flexible travel plans to match your schedule."
    },
    {
        WhyChooseheading: "Comfortable Intercity Travel Experience",
        WhyChoosedescription: "Long-distance journeys become more enjoyable with spacious seating, air-conditioned vehicles, and professional drivers."
    },
    {
        WhyChooseheading: "Pickup Available from All Pune Locations",
        WhyChoosedescription: "We provide doorstep pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, Pune Airport, and surrounding areas."
    },
    {
        WhyChooseheading: "Customized Travel Routes and Stops",
        WhyChoosedescription: "Travelers can include meal breaks, family visits, sightseeing points, overnight stays, and multiple city stops based on their itinerary."
    },
    {
        WhyChooseheading: "Trusted Choice for Maharashtra Intercity Travel",
        WhyChoosedescription: "Rising Cab Service is preferred by passengers looking for dependable, safe, and convenient transportation across Maharashtra."
    }
]
};

const faqData = [
    {
        question: "Which Vidarbha cities are covered under your cab service?",
        answer: "Our services cover Nagpur, Amravati, Akola, Yavatmal, Chandrapur, Wardha, Bhandara, Gondia, Washim, Buldhana, and nearby locations."
    },
    {
        question: "Can travelers book a one-way cab from Pune to Vidarbha?",
        answer: "Yes, one-way transportation is available to all major cities and towns across the Vidarbha region."
    },
    {
        question: "Are return-trip packages available for Vidarbha travel?",
        answer: "Yes, customers can choose round-trip packages, multi-day bookings, and customized travel plans."
    },
    {
        question: "Which vehicles are recommended for long-distance journeys?",
        answer: "Many travelers prefer Ertiga, Innova Crysta, and SUVs because of their spacious interiors and travel comfort."
    },
    {
        question: "Can business professionals use this service for official travel?",
        answer: "Yes, our Pune to Vidarbha cab service is frequently used for meetings, industrial visits, conferences, and corporate travel."
    },
    {
        question: "Do you provide vehicles for family functions and social events?",
        answer: "Yes, customers regularly book cabs for weddings, family gatherings, festivals, and personal visits across Vidarbha."
    },
    {
        question: "Can larger groups hire Tempo Travellers?",
        answer: "Yes, Tempo Travellers and group vehicles are available for family tours, pilgrimages, and corporate travel."
    },
    {
        question: "Is it possible to visit multiple Vidarbha cities during one trip?",
        answer: "Yes, customized itineraries can be planned with multiple destinations and travel stops."
    },
    {
        question: "Can passengers start the journey from Pune Airport or Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can customers reserve a Pune to Vidarbha Cab Service?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nilesh Kharat",
        feedback:
            "Our trip from Pune to Amravati was organized exceptionally well. The vehicle remained comfortable throughout the journey, and the travel arrangements were handled professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali Waghmare",
        feedback:
            "Traveling to Nagpur with family became much easier with Rising Cab Service. The driver was courteous, the ride was smooth, and the overall experience was excellent.",
        rating: 5
    }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Vidarbha Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-vidarbha-cab.jpg",
"description": "Book Pune to Vidarbha Cab Service with Rising Cab Service for safe, reliable, and comfortable long-distance travel. Enjoy outstation taxi service for one-way and round trips across Vidarbha including Yavatmal and Gadchiroli with AC cars and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-vidarbha-cab-service"
}
};







    return (
        <div>
<Helmet>
  <title>Pune to Vidarbha Cab Service | Outstation Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Vidarbha Cab Service for long-distance outstation travel. Reliable taxi service for Vidarbha region including Yavatmal and Gadchiroli with sedan, SUV, and luxury cars."
/>

<meta
 name="keywords"
 content="Vidarbha Taxi Service from Pune, Pune to Vidarbha Taxi Booking, Outstation Cab Pune to Vidarbha, Pune to Vidarbha Tour Cab, Best Vidarbha Cab Service Pune, Round Trip Vidarbha Cab Pune, Luxury Cab Pune to Vidarbha, Pune to Vidarbha Car Rental, One Way Vidarbha Taxi Pune, Pune to Yavatmal Cab Service, Pune to Yavatmal Taxi Booking, Pune to Yavatmal Innova Crysta, Pune to Yavatmal Tempo Traveller, Pune to Yavatmal Outstation Taxi, Pune to Gadchiroli Cab Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetovidharbhcabservice;